/**
 * HTML5 component templates
 */

const components = {
  input: {
    text: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<% if(selectedKeys.length) { %>
						<div class="input-group"><% } %>
							<input <% if (required) { %>required<% } %>
								type="text"
								autocomplete="off"
								class="form-control"
								name="<%=requestParameterName%>"
								placeholder="<%=placeholder%>"
								value="<% if(selectedKeys.length) { %><%= _.first(selectedKeys) %><% } %>"
							>
					<% if(selectedKeys.length) { %>
							<span class="input-group-addon" data-param-name="<%=requestParameterName%>" title="Click to clear this field"><i class="fa fa-times"></i></span>
						</div>
					<% } %>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: null,
      },
    },
    password: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<% if(selectedKeys.length) { %>
						<div class="input-group"><% } %>
							<input <% if (required) { %>required<% } %>
								type="password"
								autocomplete="off"
								class="form-control"
								name="<%=requestParameterName%>"
								placeholder="<%=placeholder%>"
								value="<% if(selectedKeys.length) { %><%= _.first(selectedKeys) %><% } %>"
							>
					<% if(selectedKeys.length) { %>
							<span class="input-group-addon" data-param-name="<%=requestParameterName%>" title="Click to clear this field"><i class="fa fa-times"></i></span>
						</div>
					<% } %>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: null,
      },
    },
    email: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<% if(selectedKeys.length) { %>
						<div class="input-group"><% } %>
							<input <% if (required) { %>required<% } %>
								type="email"
								autocomplete="off"
								class="form-control"
								name="<%=requestParameterName%>"
								placeholder="<%=placeholder%>"
								value="<% if(selectedKeys.length) { %><%= _.first(selectedKeys) %><% } %>"
								formnovalidate
							>
					<% if(selectedKeys.length) { %>
							<span class="input-group-addon" data-param-name="<%=requestParameterName%>" title="Click to clear this field"><i class="fa fa-times"></i></span>
						</div>
					<% } %>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: "Enter an email",
      },
    },
    search: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<% if(selectedKeys.length) { %>
						<div class="input-group"><% } %>
							<input <% if (required) { %>required <% } %>
								type="search"
								autocomplete="off"
								class="form-control"
								name="<%=requestParameterName%>"
								placeholder="<%=placeholder%>"
								value="<% if(selectedKeys.length) { %><%= _.first(selectedKeys) %><% } %>"
							>
					<% if(selectedKeys.length) { %>
							<span class="input-group-addon" data-param-name="<%=requestParameterName%>" title="Click to clear this field"><i class="fa fa-times"></i></span>
						</div>
					<% } %>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: "Enter a search term",
      },
    },
    url: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<% if(selectedKeys.length) { %>
						<div class="input-group"><% } %>
							<input <% if (required) { %>required <% } %>
								type="url"
								autocomplete="off"
								class="form-control"
								name="<%=requestParameterName%>"
								placeholder="<%=placeholder%>"
								value="<% if(selectedKeys.length) { %><%= _.first(selectedKeys) %><% } %>"
							>
					<% if(selectedKeys.length) { %>
							<span class="input-group-addon" data-param-name="<%=requestParameterName%>" title="Click to clear this field"><i class="fa fa-times"></i></span>
						</div>
					<% } %>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: "Enter a URL",
      },
    },
    telephone: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<% if(selectedKeys.length) { %>
						<div class="input-group"><% } %>
							<input <% if (required) { %>required <% } %>
								type="tel"
								autocomplete="off"
								pattern="<%= regex %>"
								class="form-control"
								name="<%=requestParameterName%>"
								placeholder="<%=placeholder%>"
								value="<% if(selectedKeys.length) { %><%= _.first(selectedKeys) %><% } %>"
							>
					<% if(selectedKeys.length) { %>
							<span class="input-group-addon" data-param-name="<%=requestParameterName%>" title="Click to clear this field"><i class="fa fa-times"></i></span>
					</div>
					<% } %>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: "Enter a telephone number",
      },
    },
    numeric: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<% if(selectedKeys.length) { %>
						<div class="input-group"><% } %>
							<input <% if (required) { %>required <% } %>
								type="number"
								min="<%=min%>"
								max="<%=max%>"
								step="<%=step%>"
								class="form-control"
								name="<%=requestParameterName%>"
								placeholder="<%=placeholder%>"
								value="<% if(selectedKeys.length) { %><%= _.first(selectedKeys) %><% } %>"
							>
					<% if(selectedKeys.length) { %>
							<span class="input-group-addon" data-param-name="<%=requestParameterName%>" title="Click to clear this field"><i class="fa fa-times"></i></span>
						</div>
					<% } %>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: "Enter a numeric value",
      },
    },
    numeric_range: {
      tpl: `
				<div class="form-group range-input-wrapper">
					<label class="control-label"><%= description %>:</label>
					<div class="row">
						<div class="col-xs-6 range-input-from">
							<input<% if (required) { %> required<% } %>
								class="form-control numeric-range"
								name="<%= requestParameterName %>[]"
								placeholder="From"
								data-step="<%= range.step %>"
								data-decimals="<%= decimals %>"
								<% if (Array.isArray(totalRange) && totalRange.length > 1) { %>
									data-min="<%= range.min %>"
									data-max="<%= range.max %>"
								<% } %>
								data-format="<%= format %>"
								data-value="<% if (_.isArray(currentRange) && currentRange.length>1) { %><%= currentRange[0].key %><% } %>"
								value="<% if (_.isArray(currentRange) && currentRange.length>1) { %><%= currentRange[0].key %><% } %>"
							>
						</div>
						<div class="col-xs-6 range-input-to">
							<input<% if (required) { %> required<% } %>
								class="form-control numeric-range"
								name="<%= requestParameterName %>[]"
								placeholder="To"
								data-step="<%= range.step %>"
								data-decimals="<%= decimals %>"
								<% if (Array.isArray(totalRange) && totalRange.length > 1) { %>
									data-min="<%= range.min %>"
									data-max="<%= range.max %>"
								<% } %>
								data-format="<%= format %>"
								data-value="<% if (_.isArray(currentRange) && currentRange.length>1) { %><%= currentRange[1].key %><% } %>"
								value="<% if (_.isArray(currentRange) && currentRange.length>1) { %><%= currentRange[1].key %><% } %>"
							>
						</div>
					</div>
				</div>
			`,
      options: {
        required: false,
        value: null,
      },
    },
    // single checkbox
    checkbox: {
      tpl: `
				<div class="form-group">
					<div class="checkbox">
						<label>
							<input type="checkbox"
								<% if(checked) { %> checked<% } %>
								name="<%= requestParameterName %>"
							><%= description %>
						</label>
					</div>
				</div>
			`,
      options: {},
    },
    date: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%= description %>:</label>
					<input<% if (required) { %> required<% } %>
						type="date"
						class="form-control rvc-datepicker"
						name="<%= requestParameterName %>"
						placeholder="<%= placeholder %>"
						data-value="<% if (Array.isArray(currentSelection) && currentSelection.length) { %><%= currentSelection[0].key %><% } %>"
					>
				</div>
			`,
      options: {
        required: false,
        value: null,
        placeholder: "Enter or select a date",
      },
    },
    date_range: {
      tpl: `
				<div class="form-group range-input-wrapper">
					<label class="control-label"><%= description %>:</label>
					<div class="row">
						<div class="col-xs-6 range-input-from">
							<input<% if (required) { %> required<% } %>
								type="date"
								class="form-control rvc-datepicker"
								name="<%= requestParameterName %>[]"
								placeholder="From Date"
								data-value="<% if (Array.isArray(currentRange) && currentRange.length>1) { %><%= currentRange[0].key %><% } %>"
								<% if (Array.isArray(totalRange) && totalRange.length > 1) { %>
									data-min="<%= totalRange[0].key %>"
									data-max="<%= totalRange[1].key %>"
								<% } %>
							>
						</div>
						<div class="col-xs-6 range-input-to">
							<input<% if (required) { %> required<% } %>
								type="date"
								class="form-control rvc-datepicker"
								name="<%= requestParameterName %>[]"
								placeholder="To Date"
								data-value="<% if (Array.isArray(currentRange) && currentRange.length>1) { %><%= currentRange[1].key %><% } %>"
								<% if (Array.isArray(totalRange) && totalRange.length > 1) { %>
									data-min="<%= totalRange[0].key %>"
									data-max="<%= totalRange[1].key %>"
								<% } %>
							>
						</div>
					</div>
				</div>
			`,
      options: {
        required: false,
        value: null,
      },
    },
  },
  select: {
    single: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<select class="form-control chosen-select" name="<%=requestParameterName%>">
						<option value=""></option><% _.each(options, function(option) { %>
						<option value="<%=option.key%>"<% if ( _.contains(selectedKeys, option.key) ) { %> selected<% } %>><%=option.description%></option>
					<% }); %></select>
				</div>
			`,
      options: {},
    },
    multiple: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<select multiple class="form-control chosen-select" name="<%=requestParameterName%>"><% _.each(options, function(option) { %>
						<option value="<%=option.key%>"<% if ( _.contains(selectedKeys, option.key) ) { %> selected<% } %>><%=option.description%></option>
					<% }); %></select>
				</div>
			`,
      options: {},
    },
    multiple_with_desc: {
      tpl: `
				<div class="form-group">
					<label class="control-label"><%=description%>:</label>
					<select multiple class="form-control chosen-select" name="<%=requestParameterName%>"><% _.each(options, function(option) { %>
						<option value="<%=option.key%>"<% if ( _.contains(selectedKeys, option.key) ) { %> selected<% } %>><%=option.key%>: <%=option.description%></option>
					<% }); %></select>
				</div>
			`,
      options: {},
    },
    // bootstrap-select plugin does not work well inside filters dropdown -Claude 30-Aug-2017
    // multiple_with_desc: {
    // 	tpl: "<div class=\"form-group\"><label class=\"control-label\"><%= description %>:</label><select multiple class=\"form-control selectpicker\" name=\"<%= requestParameterName %>\" data-style=\"btn-bootstrap-select\" data-icon-base=\"fa\" data-tick-icon=\"fa-check\" data-none-selected-text=\"...\"> <% _.each(options, function(option) { %> <option value=\"<%= option.key %>\" data-subtext=\"<%= option.description %>\" <% if ( _.contains(selectedKeys, option.key) ) { %> selected <% } %>><%= option.key %></option> <% }); %> </select></div>",
    // 	options: {}
    // },
    // multiple checkboxes
    checkbox: {
      tpl: `
				<% _.each(options, function(option) { %><div class="checkbox">
					<label>
						<input type="checkbox"
							<% if ( _.contains(selectedKeys, option.key) ) { %>checked<% } %>
							name="<%=requestParameterName%>"
							value="<%= option.key %>"
						>&nbsp;&nbsp;<%= option.description %>
					</label>
				</div><% }); %>
			`,
      options: {},
    },
    radio: {
      tpl: `
				<div class="form-group well well-sm">
					<label class="control-label"><%=description%>:</label><% _.each(options, function(option) { %>
					<div class="radio">
						<label>
							<input type="radio"
								<% if ( _.contains(selectedKeys, option.key) ) { %>checked<% } %>
								name="<%=requestParameterName%>"
								value="<%= option.key %>"
							>&nbsp;&nbsp;<%= option.description %>
						</label>
					</div><% }); %>
				</div>
			`,
      options: {},
    },
    range_slider: {
      tpl: `
				<div class="form-group range-slider-wrapper">
					<label class="control-label"><%= description %>:</label>
					<div id="<%= requestParameterName %>"
						class="range-slider"
						data-min="<%= range.min %>"
						data-max="<%= range.max %>"
						data-small-step="<%= range.step %>"
						<% if (range.min !== range.max) { %>
							data-value="<%= JSON.stringify(range.value) %>"
						<% } %>
						<% if (format) { %>
							data-format="<%= format %>"
						<% } %>
					>
						<input name="<%= requestParameterName %>[]" value="<%= range.value[0] %>">
						<input name="<%= requestParameterName %>[]" value="<%= range.value[1] %>">
					</div>
					<div class="selected-value text-center"></div>
				</div>
			`,
      options: {
        formatter: null,
      },
    },
  },
};

export { components as default };
